import { createSlice } from "@reduxjs/toolkit";

const uiInitalState = {
    notification:{
        status: "",
        title: "",
        message: ""
    },
    showNotification: false,
    errorOccured: false,
    errorStatus: "",
    errorMsg: ""
};

const uiSlice = createSlice({
    name: 'ui',
    initialState: uiInitalState,
    reducers: {
        showNotification(state,action){
            state.notification = {
                status: action.payload.status,
                title: action.payload.title,
                message: action.payload.message
            };
            state.showNotification = true;
        },
        clearNotification(state, action){
            state.notification = uiInitalState.notification;
            state.showNotification = false;
        },
        hideNotification(state, action){
            state.showNotification = false;
        },
        error(state, action){
            state.errorStatus = action.payload.status;
            state.errorMsg = action.payload.msg;
        }
    }
});

export const { actions } = uiSlice;
export const { reducer } = uiSlice;